import { render, staticRenderFns } from "./RecognitionCard.vue?vue&type=template&id=ef93cb9a&scoped=true"
import script from "./RecognitionCard.vue?vue&type=script&lang=js"
export * from "./RecognitionCard.vue?vue&type=script&lang=js"
import style0 from "./RecognitionCard.vue?vue&type=style&index=0&id=ef93cb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef93cb9a",
  null
  
)

export default component.exports